import { Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private appConfig: AppConfig) {}

    /**
     * Redirect to BFF login endpoint.
     * Stores the redirect route in sessionStorage for post-login navigation.
     */
    public initLogin(redirectUrl: string | null = null): void {
        if (redirectUrl) {
            sessionStorage.setItem('bff_redirect_route', redirectUrl);
        }
        const callbackUrl = encodeURIComponent(
            window.location.origin + '/login-callback'
        );
        window.location.href = `${this.appConfig.bffUrl}/auth/login?callback_url=${callbackUrl}`;
    }

    /**
     * Redirect to BFF RP-Initiated logout endpoint.
     * The browser walks the Keycloak end_session_endpoint chain (propagating
     * logout to external IdPs via id_token_hint), returns to the BFF's
     * /auth/logout/callback, and finally lands on `callback_url`.
     */
    public logout(): void {
        this.clearPostLoginRedirect();
        const callbackUrl = encodeURIComponent(
            window.location.origin + '/login'
        );
        window.location.href = `${this.appConfig.bffUrl}/auth/logout?callback_url=${callbackUrl}`;
    }

    /**
     * Returns the stored redirect route from sessionStorage (saved before BFF login redirect).
     */
    public getPostLoginRedirect(): string {
        return sessionStorage.getItem('bff_redirect_route') || '/';
    }

    /**
     * Clears the stored redirect route.
     */
    public clearPostLoginRedirect(): void {
        sessionStorage.removeItem('bff_redirect_route');
    }
}
